var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvrLogoFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 249.43208 49.01434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "      .cls-1 {        fill: #fff;      }      .cls-2, .cls-3 {        fill: none;        stroke-linecap: round;        stroke-linejoin: round;        stroke-width: 8.008px;      }      .cls-2 {        stroke: url(#linear-gradient);      }      .cls-3 {        stroke: url(#linear-gradient-2);      }    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 56.44816,
    y1: 49.01434,
    x2: 56.44816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0683ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57672,
    stopColor: "#06c4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 128.79007,
    y1: 48.88674,
    x2: 128.79007,
    y2: 0.43597,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AVR Logo Final") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.59126,28.06958h3.03125V45.85571h12.41016v2.63086H176.59126Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.227,38.19262c.37207-3.74609,2.94531-5.2041,7.43457-5.2041,3.05957,0,6.8916.77149,6.8916,4.25977v8.06445c0,.88672.40039,1.28613,1.28613,1.28613a5.59662,5.59662,0,0,0,1.001-.11425v2.002a14.65483,14.65483,0,0,1-2.23047.17187c-1.42969,0-2.37305-.40039-2.57324-2.08789-1.14356,1.544-3.94629,2.43067-6.377,2.43067-4.97558,0-6.09082-2.57325-6.09082-4.51758,0-2.74512,1.62988-4.14649,6.43457-4.66113l3.25977-.34375c1.60156-.1709,2.60156-.457,2.60156-1.80079,0-2.05957-2.001-2.459-4.31738-2.459-2.459,0-4.54688.65723-4.63281,2.97363Zm11.63769,2.459c-.42871.48633-1.20019.68652-2.80176.88672l-3.23144.40039c-2.23047.28515-3.40235.88574-3.40235,2.459,0,1.40137,1.40039,2.373,3.48828,2.373,3.23145,0,5.94727-1.71582,5.94727-4.20313Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.73189,27.89868h2.85937V35.762h.05762c1.14355-1.80176,3.46-2.60254,5.69043-2.60254,4.51758,0,8.14941,2.88867,8.14941,7.9209,0,5.0332-3.63183,7.9209-8.14941,7.9209-2.20215,0-4.5752-.85743-5.69043-2.43067h-.05762v1.916h-2.85937Zm8.23535,7.66308a5.15678,5.15678,0,0,0-5.54688,5.51856,5.17225,5.17225,0,0,0,5.54688,5.51855c3.86035,0,5.49023-2.6875,5.49023-5.51855A5.12732,5.12732,0,0,0,222.96724,35.56176Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.10786,43.76879c0,1.34375,1.08692,3.002,4.71778,3.002,3.68945,0,4.57519-1.28711,4.57519-2.34473s-.543-1.6875-2.83105-2.002l-4.71777-.62891c-2.14454-.28613-4.06055-1.6582-4.06055-3.97461,0-3.03125,2.63086-4.832,6.834-4.832,4.91895,0,7.06348,2.11524,7.32032,5.03223h-2.85938c-.08594-1.51563-1.51562-2.80176-4.48926-2.80176-1.83008,0-3.94629.51465-3.94629,2.28711,0,1.001.458,1.57227,2.48828,1.8584l4.06055.54394c3.77442.51465,5.23242,1.8584,5.23242,3.97461,0,3.48828-2.94531,5.11817-7.5205,5.11817-3.43165,0-7.34864-.88672-7.66309-5.23243Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.51938,44.48231H10.81218A6.7953,6.7953,0,0,1,5.55194,33.38516L27.704,6.298a6.25186,6.25186,0,0,1,9.64238-.04452L67.81679,42.818a6.09285,6.09285,0,0,0,9.39626-.04233l31.67927-38.7191"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.24138,44.88274,121.67153,8.09505A9.739,9.739,0,0,1,129.27638,4.44h27.35316c11.61228,1.62236,11.6123,18.39876,0,20.02115H128.48984a3.98431,3.98431,0,0,0-1.532,7.66233l29.6716,12.35884"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvrLogoFinal);
export default __webpack_public_path__ + "static/media/AVR-Logo-Final.5aa497d63e5944f4261f25d135139bf9.svg";
export { ForwardRef as ReactComponent };